// extracted by mini-css-extract-plugin
export default {"close":"index_close_5Hrds","num":"index_num_dWJTD","current":"index_current_-vLI5"};